import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Customer() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Customer Name",
      accessorKey: "CustomerName",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
    },
    {
      header: "Customer Vat No",
      accessorKey: "CustomerVatNo",
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "DOB",
      accessorKey: "DOB",
    },
    {
      header: "DOA",
      accessorKey: "DOA",
    },
    {
      header: "Address",
      accessorKey: "Address",
    },
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([
    {
      SN: 1,
      CustomerName:"Abdul Wahab",
      Phone: "03112564099",
      CustomerVatNo:"",
      Email: "",
      DOB: "0000-00-00",
      DOA: "1969-12-31",
      Address: "Karachi",
      AddedBy: "Demo Test Account"
    },
    {
      SN: 2,
      CustomerName:"zohaib mumtaz	",
      Phone: "03112564099",
      CustomerVatNo:"",
      Email: "",
      DOB: "0000-00-00",
      DOA: "1969-12-31",
      Address: "Karachi",
      AddedBy: "Demo Test Account"
    }, 
     {
      SN: 3,
      CustomerName:"وافي",
      Phone: "03112564099",
      CustomerVatNo:"",
      Email: "",
      DOB: "0000-00-00",
      DOA: "1969-12-31",
      Address: "Karachi",
      AddedBy: "Demo Test Account"
    }
  ]);
  const [buttonData] = useState([   
    {
      buttonText: "Add Customer",
      path: "addCustomerForm"
    },
    {
      buttonText: "Upload Customer",
      path: "uploadCustomer"
    },
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Customers"}
        buttonData={buttonData}
      

      />
    </main>
  );
}

export default Customer;
